<template>
  <div>
    <ValidationObserver ref="observer">
      <form slot-scope="{ handleSubmit }" @submit.prevent="handleSubmit(onSubmit)">
        <ValidationProvider rules="required|between:3,255" vid="customerName" name="Họ tên khách hàng">
          <b-form-group slot-scope="{ errors }">
            <label>Họ tên khách hàng <span style="color: red;">*</span></label>
            <b-form-input
              type="text"
              v-model="form.customerName"
              :state="errors[0] ? false : null"
            ></b-form-input>
            <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>

        <ValidationProvider :rules="!permissionAgent ? 'required' : '' " vid="mobile" name="Số điện thoại">
          <b-form-group slot-scope="{ errors }">
            <label>Số điện thoại <span v-show="!permissionAgent" style="color: red;">*</span></label>
            <b-form-input
              type="tel"
              v-model="form.mobile"
              :state="errors[0] ? false : null"
            ></b-form-input>
            <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>

        <ValidationProvider v-if="permissionAgent" rules="required" vid="contactPhoneNumber" name="Số điện thoại liên hệ">
          <b-form-group slot-scope="{ errors }">
            <label>Số điện thoại liên hệ <span style="color: red;">*</span></label>
            <b-form-input
              type="tel"
              v-model="form.contactPhoneNumber"
              :state="errors[0] ? false : null"
            ></b-form-input>
            <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>

        <ValidationProvider rules="mail" vid="email" name="Email">
          <b-form-group slot-scope="{ errors }" label="Email">
            <b-form-input
              type="text"
              v-model="form.email"
              :state="errors[0] ? false : null"
            ></b-form-input>
            <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>

        <ValidationProvider v-if="permissionAgent" rules="required|min:5" vid="vaNumber" name="Số tài khoản VA">
          <b-form-group slot-scope="{ errors }">
            <label>Số tài khoản VA <span style="color: red;">*</span></label>
            <b-form-input
              type="text"
              v-model="form.vaNumber"
              :state="errors[0] ? false : null"
            ></b-form-input>
            <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>

        <ValidationProvider rules="required|between:3,255" vid="merchantName" name="Tên cửa hàng / Merchant">
          <b-form-group slot-scope="{ errors }">
            <label>Tên cửa hàng / Merchant <span style="color: red;">*</span></label>
            <b-form-input
              type="text"
              v-model="form.merchantName"
              :state="errors[0] ? false : null"
            ></b-form-input>
            <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>

        <div class="row">
          <div class="col-md-6">
            <ValidationProvider rules="required" vid="cityCode" name="Tỉnh/thành phố" v-slot="{ errors, validate }">
              <b-form-group>
                <label>Tỉnh/thành phố <span style="color: red;">*</span></label>
                <Select2
                  v-model="form.cityCode"
                  :options="provinceList"
                  placeholder="Chọn tỉnh/thành phố"
                  @close="validate()"
                  @change="onChangeProvince($event)">
                </Select2>
                <b-form-invalid-feedback :state="errors[0] ? false : null">{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>
          </div>
          <div class="col-md-6">
            <ValidationProvider rules="required" vid="districtCode" name="Quận/huyện">
              <b-form-group slot-scope="{ errors, validate }">
                <label>Quận/huyện <span style="color: red;">*</span></label>
                <Select2
                  v-model="form.districtCode"
                  :options="districtList"
                  @close="validate()"
                  placeholder="Chọn Quận/huyện">
                </Select2>
                <b-form-invalid-feedback :state="errors[0] ? false : null">{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>
          </div>
          <div class="col-md-6">
            <ValidationProvider vid="wardCode" name="Phường/xã">
              <b-form-group slot-scope="{ errors }">
                <label>Phường/xã</label>
                <Select2
                  v-model="form.wardCode"
                  placeholder="Chọn Phường/xã"
                  :options="wardList">
                </Select2>
                <b-form-invalid-feedback :state="errors[0] ? false : null">{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>
          </div>
          <div class="col-md-6">
            <ValidationProvider
              rules="required"
              vid="expectedDeliveryDate"
              name="Thời gian giao hàng mong muốn"
            >
              <b-form-group slot-scope="{ errors }">
                <label>Thời gian giao hàng mong muốn <span style="color: red;">*</span></label>
                  <input type="date" class="form-control" v-model="expectedDeliveryDate" @focus="openDatePicker" @blur="onValidateTime">
                <b-form-invalid-feedback :state="errors[0] ? false : null">{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>
          </div>
        </div>

        <div v-if="permissionAgent" class="row">
          <div class="col-md-6">
            <ValidationProvider rules="required|integer|min_value:1" vid="deviceQuantity" name="Số lượng máy">
              <b-form-group slot-scope="{ errors }">
                <label>Số lượng máy <span style="color: red;">*</span></label>
                <b-form-input
                  type="number"
                  step="1"
                  v-model="form.deviceQuantity"
                  placeholder="Nhập số lượng máy"
                ></b-form-input>
                <b-form-invalid-feedback :state="errors[0] ? false : null">{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>
          </div>

          <div class="col-md-6">
            <ValidationProvider rules="required" vid="handoverType" name="Hình thức bàn giao">
              <b-form-group slot-scope="{ errors, validate }">
                <label>Chọn hình thức bàn giao <span style="color: red;">*</span></label>
                <Select2
                  v-model="form.handoverType"
                  :options="optionsDeliveryMethods"
                  @close="()=>validate()"
                  placeholder="Chọn hình thức bàn giao"
                  />
                <b-form-invalid-feedback :state="errors[0] ? false : null">{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>
          </div>
        </div>

        <ValidationProvider rules="required|between:3,255" vid="address" name="Địa chỉ">
          <b-form-group slot-scope="{ errors }">
            <label>Địa chỉ <span style="color: red;">*</span></label>
            <b-form-input
            type="text"
            v-model="form.address"
            :state="errors[0] ? false : null"
            ></b-form-input>
            <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>

        <ValidationProvider vid="mcc" name="Ngành nghề">
          <b-form-group slot-scope="{ errors }" label="Ngành nghề">
            <Select2
              v-model="form.mcc"
              :options="businessFields">
            </Select2>
            <b-form-invalid-feedback :state="errors[0] ? false : null">{{ errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>

        <ValidationProvider rules="" vid="description" name="Ghi chú">
          <b-form-group slot-scope="{ errors }" label="Ghi chú">
            <b-form-input
              type="text"
              v-model="form.description"
              :state="errors[0] ? false : null"
            ></b-form-input>
            <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>

        <div class="flex-wrap d-flex" style="gap: 10px;">
          <UploadMultiple
            :lsData="form.uploadImages"
            @syncFile="(fileUploads) => files = fileUploads"
            title="Ảnh"
          />
        </div>

        <div class="d-flex" style="gap: 10px">
          <button type="button" @click="back" class="btn btn-light w-100">
            Huỷ
          </button>
          <button type="submit" class="btn btn-primary w-100 text-white">
            Lưu
          </button>
        </div>
      </form>
    </ValidationObserver>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true">
    </VueLoadingOverlay>
  </div>
</template>

<script>
import UploadMultiple from '@/components/UploadMultiple.vue'
import moment from 'moment'
import { extend } from 'vee-validate'
import { integer, min_value } from 'vee-validate/dist/rules'

extend('integer', {
  ...integer,
  message: '{_field_} phải là số nguyên'
})

extend('min_value', {
  ...min_value,
  message: '{_field_} phải lớn hơn hoặc bằng {min}'
})

const optionsDeliveryMethods = [
  { id: 'OFFLINE', text: 'Offline' },
  { id: 'ONLINE', text: 'Online' }
]
export default {
  props: {
    form: Object
  },
  data () {
    return {
      showLoading: false,
      provinceList: [],
      districtList: [],
      wardList: [],
      businessFields: [],
      files: null,
      optionsDeliveryMethods,
      dataUser: JSON.parse(localStorage.getItem('userData')),
      expectedDeliveryDate: ''
    }
  },
  components: { UploadMultiple },
  computed: {
    permissionAgent () {
      return this.dataUser?.partnerCode === 'VCBHO'
    }
    // typeOfCountry () {
    //   return this.permissionAgent ? 'wardCode' : 'districtCode'
    // }
  },
  async created () {
    this.showLoading = true
    try {
      this.provinceList = await this.getProvinceMx()
      const config = await this.getConfigMx()
      this.businessFields = config.businessFields.map((e) => {
        return { id: e.code, text: e.name }
      })
    } catch (error) {
    } finally {
      this.showLoading = false
    }
  },
  // watch: {
  //   'form.expectedDeliveryTime': {
  //     immediate: true,
  //     handler (newVal) {
  //       this.expectedDeliveryDate = newVal
  //         ? moment(newVal).format('YYYY-MM-DD')
  //         : ''
  //     }
  //   }
  // },
  methods: {
    setExpectedDeliveryDate (value) {
      if (value) {
        this.expectedDeliveryDate = value
          ? moment(value).format('YYYY-MM-DD')
          : ''
      }
    },
    onValidateTime () {
      this.$refs.observer.setErrors({
        expectedDeliveryDate: 'Thời gian giao hàng mong muốn là bắt buộc'
      })
    },
    openDatePicker (event) {
      event.target.showPicker()
    },
    async onChangeProvince (cityCode) {
      this.form.wardCode = ''
      this.form.districtCode = ''
      // this.form[this.typeOfCountry] = ''
      // const mapFunc = {
      //   VCBHO: this.getWardMx
      // }
      // const func = mapFunc[this.dataUser.partnerCode] || this.getDistrictMx
      // this.districtList = await func({ cityCode })
      await this.getDistrict(cityCode)
      await this.getWard(cityCode)
    },
    async getDistrict (cityCode) {
      this.districtList = await this.getDistrictMx({ cityCode })
    },
    async getWard (cityCode) {
      this.wardList = await this.getWardMx({ cityCode })
    },
    back () {
      this.$router.push('/merchant')
    },
    async onSubmit () {
      this.showLoading = true
      if (this.files) this.form.uploadImages = await Promise.all(this.files.map(s => this.sendFileMx(s)))
      this.showLoading = false
      const params = {
        ...this.form,
        expectedDeliveryTime: moment(this.expectedDeliveryDate).valueOf(),
        agentId: this.dataUser.agentId,
        city: this.provinceList.find((s) => s.id === this.form.cityCode)?.text,
        // [this.permissionAgent ? 'ward' : 'district']: this.districtList.find((s) => s.id === this.form[this.typeOfCountry])?.text
        ward: this.wardList.find((s) => s.id === this.form.wardCode)?.text,
        district: this.districtList.find((s) => s.id === this.form.districtCode).text
      }
      this.$emit('submit', params)
    }
  }
}
</script>

<style scoped>
.required-asterisk {
  color: red;
}
</style>
